import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import { IStorePremiumProduct } from 'protos'

import T from 'components/FormattedMessage'
import Button from 'components/Button'

interface Props {
  className?: string
  membership?: IStorePremiumProduct
}

type InjectedProps = Props & RouteComponentProps<{}>

const MoreInfoButton: React.SFC<InjectedProps> = ({ membership, className, match }) => {
  const to = membership
    ? `${match.path}/${membership.productId}`
    : `/store/premium-accounts`

  return (
    <Button
      to={to}
      color="accent"
      variant="contained"
      className={className}
    >
      <T id="store_premium_showdetails" />
    </Button>
  )
}

export default withRouter(MoreInfoButton)
try {
    // @ts-ignore
    MoreInfoButton.displayName = "MoreInfoButton";
    // @ts-ignore
    MoreInfoButton.__docgenInfo = { "description": "", "displayName": "MoreInfoButton", "props": { "wrappedComponentRef": { "defaultValue": null, "description": "", "name": "wrappedComponentRef", "required": false, "type": { "name": "Ref<any>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PremiumMembership/MoreInfoButton.tsx#MoreInfoButton"] = { docgenInfo: MoreInfoButton.__docgenInfo, name: "MoreInfoButton", path: "src/components/PremiumMembership/MoreInfoButton.tsx#MoreInfoButton" };
}
catch (__react_docgen_typescript_loader_error) { }